module.exports = new __parcel__URL__("imagen_oculta.d38fbbc6.png").toString();